import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';

export function getNextPointsRenewalDate(cycle: $TSFixMe) {
  if (cycle === 'monthly') {
    return moment().add(1, 'months').startOf('month');
  }

  if (cycle === 'quarterly') {
    return moment().startOf('quarter').add(1, 'quarter');
  }

  return moment().add('1', 'year').startOf('year');
}

export function stipendEnabled(company: $TSFixMe) {
  return company.features.stipend;
}

export function getAmountToPointRatio(company: $TSFixMe) {
  return company.features.stipend &&
    company.features.stipend_config &&
    !company.features.stipend_config.display_as_amount
    ? company.features.stipend_config.amount_to_points_ratio
    : 1;
}

export function getVendorSponsorshipAmount(
  company: $TSFixMe,
  vendor: $TSFixMe,
  product: $TSFixMe,
  total_amount: $TSFixMe
) {
  const product_categories = product.categories;
  const excluded_categories = company.settings.wallet_excluded_categories || [];

  const final_categories = product_categories.filter(
    (category: $TSFixMe) => excluded_categories.indexOf(category) === -1
  );

  const is_excluded = final_categories.length === 0;
  return is_excluded
    ? 0
    : numeral(total_amount || product.special_price).value();
}

export function getPreferredWalletName(
  company: $TSFixMe,
  company_wallet_configuration_id: $TSFixMe
) {
  const wallet_config = _.find(
    company.company_wallet_configurations,
    (config) => config.id === company_wallet_configuration_id
  );

  if (!wallet_config) {
    return '';
  }

  return wallet_config.wallet_name.replace(/account|wallet/i, '');
}

export function getWalletDisplayName(name: $TSFixMe) {
  return name.replace(/account|wallet/i, '');
}
